module.exports = __webpack_public_path__ + "assets/img/jp.f77e2266.png";